<div [id]="field.attributes.id" (blur)="touch()">
  @for (option of options; track option) {
  <div>
    <label class="checkboxes-label">
      <input
        type="checkbox"
        [(checklist)]="value"
        [checklistValue]="option.id"
        [disabled]="disabled"
      />
      <span>{{ option.value }}</span>
    </label>
  </div>
  }
</div>
